import BaseCom from "../../../components/BaseCom";
import { SidebarGlobal } from "../../../components/Bridge/Sidebar";
import FormInputV2 from "../../../components/FormInputV2";
import { qreq } from "../../../shared/qrequest";

const APIComCache = {
    clients: null,
    credentials: null
};

export default class APICom extends BaseCom {

    constructor(props) {
        super(props);
        this.state = {
            query: {}
        };
    }

    async componentDidMount() {
        await this.loadAPIClients();
    }

    loadAPIClients = async (noCreds) => {

        if(APIComCache.clients && APIComCache.credentials) {
            this.setState({ clients: APIComCache.clients, credentials: APIComCache.credentials });
            this.setSubNav(APIComCache.clients, APIComCache.credentials, noCreds);
            return;
        }
        try {
            let j = await qreq.getAsync('/api/api-client/list');
            let k = await qreq.getAsync('/api/api-credential/list');
            if (j.list && k.list) {
                this.setState({ clients: j.list, credentials: k.list });
                this.setSubNav(j.list, k.list, noCreds);
            }
        }
        catch (e) {
            this.unkownErrorCallback(e);
        }
    }

    setSubNav = (clients, creds, noCreds) => {
        SidebarGlobal.setSubNav(<>
            <div>
                <FormInputV2 model={this.state.query} name="clientID" type="select" selectDefault="Select Client" options={clients} onChange={this.clientChange} useObjectValue />
            </div>
            {!noCreds && <div className="ms-2">
                <FormInputV2 model={this.state.query} name="credsID" type="select" selectDefault="Select Credentials" options={creds} onChange={this.credsChange} useObjectValue />
            </div>}
        </>);
    }


    
    clientChange = (v) => {
        this.setState({ currentClient: v, modifiedPath: null });
        APIComCache.currentClient = v;
    }

    credsChange = (v) => {
        this.setState({ currentCreds: v, modifiedPath: null });
        APIComCache.currentCreds = v;
    }

    
}